export default __webpack_public_path__ + "static/media/general.2cd0ab2c.svg";